import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, monthlyInvoicesData } from '../../../../Data/DashboardsData/ECommerceData'
import { InvoicesTitle } from '../../../../Utils/Constants'
import { H4, H5, LI, UL } from '../../../../AbstractElements'
import SvgIcon from '../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { Link } from 'react-router-dom'

export default function Invoices() {
    return (
        <Col xxl={4} xl={6} sm={6} className="box-col-6">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={InvoicesTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    <div className="monthly-invoices">
                        <UL className='simple-list'>
                            {monthlyInvoicesData.map((item) => (
                                <LI key={item.id}>
                                    <div className="monthly-data">
                                        <div className="invoice-data-icon">
                                            <span>
                                                <SvgIcon iconId={item.icon} />
                                            </span>
                                            <div>
                                                <Link to={`${process.env.PUBLIC_URL}/invoice/${item.link}`}>
                                                    <H4>{item.title}</H4>
                                                </Link>
                                                <H5>{item.subText}</H5>
                                            </div>
                                        </div>
                                        <div className="invoice-price">
                                            <span>${item.price}</span><span>{'Per Week'}</span>
                                        </div>
                                    </div>
                                </LI>
                            ))}
                            <LI>
                                <Link className="btn active w-100 d-flex gap-2 align-items-center" to={`${process.env.PUBLIC_URL}/applications/ecommerce/add-products`}>
                                    <SvgIcon iconId='Plus-Circle' />
                                    {'Add Product'}
                                </Link>
                            </LI>
                        </UL>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}